import React from 'react';
import { View, Text, Image } from '@react-pdf/renderer';
import styles from './PagesStyle/HeaderStyles'; // New styles for the header

const getCurrentDate = () => {
  return new Date().toLocaleDateString('en-US');
};

const Header = ({ companyLogo, formData = {} }) => (
  <View style={styles.headerContainer}>
    <View style={styles.leftSection}>
      <Text style={styles.title}>DIMINISHED VALUE APPRAISAL</Text>
      <View style={styles.row}>
        <Text style={styles.subTitle}>REPORT DATE: </Text>
        <Text style={{ fontSize: 8, color: '#00607F', right: 10}}>{getCurrentDate()}</Text>
      </View>
      <View style={styles.row}>
        <Text style={styles.subTitles}>VEHICLE ID: </Text>
        <Text style={{ fontSize: 8, color: '#00607F' }}>{formData.vin || 'N/A'}</Text>
      </View>
    </View>
    <View style={styles.rightSection}>
      <Image style={styles.logo} src={companyLogo || '/logo (1).png'} /> // Fallback image
    </View>
  </View>
);

export default Header;